import {
  NoConfirmationDefaultNavigatorConfiguration,
  NoConfirmationPreQualifiedPatientNavigatorConfiguration
} from "../../App/Compositions/NavigatorConfigurations";
import {
  noConfirmationCenterSelectableBookingStepConfigurations,
  screeningStepConfigurations
} from "../../App/Compositions/StepConfigurations";
import { Flow } from "../../Types/IFlow";

const noWelcomeNoBookFlowName = "NoWelcomeNoBookFlow";

/** Legacy flow name alias. Routes users with cached "NoWelcomeNoBookFlow" sessions to the no-confirmation experience. */
class NoWelcomeNoBookFlow extends Flow {
  static readonly flowName = noWelcomeNoBookFlowName;

  constructor(isPatientPreQualified: boolean) {
    isPatientPreQualified
      ? super(
          noWelcomeNoBookFlowName,
          { ...noConfirmationCenterSelectableBookingStepConfigurations },
          NoConfirmationPreQualifiedPatientNavigatorConfiguration
        )
      : super(
          noWelcomeNoBookFlowName,
          { ...screeningStepConfigurations, ...noConfirmationCenterSelectableBookingStepConfigurations },
          NoConfirmationDefaultNavigatorConfiguration
        );
  }
}

export default NoWelcomeNoBookFlow;
